import { EviteModal }  from './index';
import urls from 'urls';

class SendSMSModal {

    settings = {
        guest_id: '',
        phone: '',
        not_you_flow: true,
        url: urls.get('send_sms_modal', {
            event_id: window.event_id
        })
    };

    constructor(settings) {
        this.settings.url_parameters = {
            guest_id: this.settings.guest_id,
            phone: this.settings.phone,
            not_you_flow: this.settings.not_you_flow
        };
        return new EviteModal(Object.assign({}, this.settings, settings))
    };

};

export default SendSMSModal;


// WEBPACK FOOTER //
// ./assets/es6/modal/send_sms_modal.es6